import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  heroCheckBadge,
  heroInformationCircle,
} from '@ng-icons/heroicons/outline';
import {
  ionBusinessOutline,
  ionMailOutline,
  ionPersonOutline,
  ionTimerOutline,
} from '@ng-icons/ionicons';
import { JobOfferService } from 'src/app/api/services';
import { JobOfferPostulantService } from 'src/app/api/services/job-offer-postulant.service';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';
import { POSTULANT_STATUS_MESSAGES } from 'src/app/core/constant/status-postulant-messages';
import { NavButtonComponent } from 'src/app/shared/component/nav-button/nav-button.component';
import { JobOfferDetails } from 'src/app/shared/model/job-offer-detail';
import { JobOfferPostulantDetail } from 'src/app/shared/model/job-offer-postulant';
import { TimeAgoPipe } from 'src/app/shared/pipe/time-ago.pipe';

@Component({
  selector: 'app-job-offer-postulant-detail',
  imports: [NgIcon, CommonModule, TimeAgoPipe, NavButtonComponent],
  templateUrl: './job-offer-postulant-detail.component.html',
  viewProviders: [
    provideIcons({
      ionMailOutline,
      ionTimerOutline,
      ionBusinessOutline,
      ionPersonOutline,
      heroInformationCircle,
      heroCheckBadge,
    }),
  ],
})
export class JobOfferPostulantDetailComponent implements OnInit {
  postulantDetail?: JobOfferPostulantDetail;
  jobDetail?: JobOfferDetails;

  loading: boolean = false;
  errorMessage?: string;
  postulantSteps = POSTULANT_STATUS_MESSAGES;

  constructor(
    private route: ActivatedRoute,
    private jobOfferPostulantService: JobOfferPostulantService,
    private jobOfferService: JobOfferService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      this.loading = true;

      this.jobOfferPostulantService.getPostulantDetailById(id).subscribe({
        next: (res) => {
          if (res.type === 'success') {
            this.postulantDetail = res.dto.jobOfferPostulant;

            const jobId = this.postulantDetail.idJobOffer;
            this.jobOfferService.getJobDetailById(jobId).subscribe({
              next: (jobRes) => {
                if (jobRes.type === 'success') {
                  this.jobDetail = jobRes.dto.jobOffer;
                }
                this.loading = false;
              },
              error: (err) => {
                this.loading = false;
              },
            });
          } else {
            this.loading = false;
          }
        },
        error: (err) => {
          this.loading = false;
        },
      });
    }
  }

  isStepActive(stepNumber: number): boolean {
    const order = ['Enviado', 'Revisado', 'Preseleccionado', 'Seleccionado'];
    const currentIndex = order.indexOf(
      this.postulantDetail?.statusProcess || 'Enviado'
    );
    return stepNumber - 1 <= currentIndex;
  }
  isLineActive(stepNumber: number): boolean {
    return this.isStepActive(stepNumber + 1);
  }

  isVerified(): boolean {
    if (
      this.postulantDetail?.job_offer.company_package.company.verified === '1'
    ) {
      return true;
    } else {
      return false;
    }
  }

  companyBanner(): string {
    if (!this.jobDetail) {
      return APP_CONSTANTS.DEFAULT_BANNER_COMPANY;
    }
    const url = this.jobDetail.company.urlBannerMvv;
    if (!url || url.trim() === '') {
      return APP_CONSTANTS.DEFAULT_BANNER_COMPANY;
    }
    return url;
  }
}
